import domtoimage from 'dom-to-image'
import { NextPage } from 'next'
import Head from 'next/head'
import { QRCodeSVG } from 'qrcode.react'
import { useState } from 'react'
import { useTranslation } from 'react-i18next'
import useSWR from 'swr'
import { useAccount } from 'wagmi'
import { getInvitationCode } from '~/apis'
import Footer from '~/components/Footer'
import Header from '~/components/Header'
import { Loading } from '~/components/Loading'
import { message } from '~/components/Message'
import { useBreakpoint, useGA } from '~/hooks'
import { StyledLonPageHelper } from '../../styled'
import { StyledShareWrapper } from './styled'
import { ASSET_PREFIX } from '~/constants/env'

const Share: NextPage = () => {
  const { isMobile } = useBreakpoint()
  const { t } = useTranslation()
  const { trackElClickCurring } = useGA()

  const [sharing, setSharing] = useState(false)

  const { address } = useAccount()
  const connected = !!address
  const { data: invitation, isValidating: isLoading } = useSWR(
    ['getInvitationCode', address],
    () => getInvitationCode(address),
  )
  const code = invitation?.code

  const shareUrl = `https://tokenlon.im/lon/mining/trade/activate?r=${code}`

  const onShareURL = () => {
    if (isMobile) {
      window.imToken?.callAPI(
        'native.share',
        {
          title: t('invitation_code'),
          message: `${t('invitation_code')} ${code}`,
          url: `${window.location.origin}/lon/mining/trade/activate?r=${code}`,
        },
        (err) => {
          if (err) {
            if (err.code === 1001) {
            }
          } else {
            setSharing(false)
          }
        },
      )
    } else {
      const input = document.createElement('input')
      document.body.appendChild(input)
      input.setAttribute(
        'value',
        `${window.location.origin}/lon/mining/trade/activate?r=${code}`,
      )
      input.select()
      if (document.execCommand('copy')) {
        document.execCommand('copy')
      }
      document.body.removeChild(input)
      message.success(t('url_cpoied'))
    }
  }

  const onShareImage = () => {
    const canvas = document.getElementById('canvas')
    canvas.style.visibility = 'visible'
    const modal = document.getElementById('sharing-modal')
    modal.style.background = 'rgba(50, 56, 72, 1)'
    domtoimage
      .toPng(document.getElementById('canvas'), { quality: 1 })
      .then((dataUrl) => {
        canvas.style.visibility = 'hidden'
        modal.style.background = 'rgba(50, 56, 72, 0.7)'
        if (isMobile) {
          window.imToken?.callAPI(
            'native.share',
            {
              message: `${t('invitation_code')} ${code}`,
              url: dataUrl,
              type: 'image/png',
            },
            (err) => {
              if (err) {
                if (err.code === 1001) {
                }
              } else {
                setSharing(false)
              }
            },
          )
        } else {
          const link = document.createElement('a')
          link.download = 'LON Code.jpg'
          link.href = dataUrl
          link.click()
        }
      })
  }

  return (
    <StyledLonPageHelper>
      <Head>
        <title>{t('meta_lon_trade_title')}</title>
        <meta name="description" content={t('meta_lon_trade_description')} />
        <meta name="keywords" content={t('meta_lon_keywords')} />
      </Head>
      <Header />
      <StyledShareWrapper>
        <div className="lon-share">
          {isLoading && (
            <div className="share-card">
              <Loading />
            </div>
          )}
          {!isLoading && (
            <div className="share-card" id="share-card">
              <img src={`${ASSET_PREFIX}/images/lon/lon-invite-tft.svg`} />
              <div className={`code-wrap tft`}>
                <p className="title">{t('invitation_code')}</p>
                <p className="code">{code}</p>
              </div>
              {connected ? (
                <button
                  className="tft"
                  data-trackid="webtl_tmcode_share"
                  onClick={(e) =>
                    trackElClickCurring(e)(() => setSharing(true))
                  }
                >
                  {t('share')}
                </button>
              ) : (
                <p className="no-invitation">{t('no_invitation_code_yet')}</p>
              )}
            </div>
          )}
          {!isLoading && (
            <p className="desc">
              <span>{t('tfter_share_friends')}</span>
            </p>
          )}
          <div id="canvas" className="canvas">
            <div className="share-card" id="share-card">
              <img src={`${ASSET_PREFIX}/images/lon/lon-invite-tft.svg`} />
              <div className={`code-wrap tft`}>
                <p className="title">{t('invitation_code')}</p>
                <p className="code">{code}</p>
              </div>
              <div className="card-footer">
                <p>{shareUrl}</p>
                <div className="qrcode-wrap">
                  <QRCodeSVG value={shareUrl} size={138} />
                </div>
              </div>
            </div>
            <p className="desc">
              <span>{t('tfter_share_friends')}</span>
            </p>
          </div>
          {sharing && (
            <div className="sharing-modal" id="sharing-modal">
              <div
                className="button-container"
                style={{ paddingBottom: isMobile ? 20 : 0 }}
              >
                <img
                  className="close-o"
                  src={`${ASSET_PREFIX}/images/lon/close.svg`}
                  onClick={() => setSharing(false)}
                />
                <div className="row">
                  <div
                    className="col"
                    data-trackid="webtl_tmcode_share_pic"
                    onClick={(e) => trackElClickCurring(e)(onShareImage)}
                  >
                    <div>
                      <img
                        src={`${ASSET_PREFIX}/images/lon/download.svg`}
                        alt="download"
                      />
                    </div>
                    <span>{t('share_image')}</span>
                  </div>
                  <div
                    className="col"
                    data-trackid="webtl_tmcode_share_link"
                    onClick={(e) => trackElClickCurring(e)(onShareURL)}
                  >
                    <div>
                      <img
                        src={`${ASSET_PREFIX}/images/lon/share.svg`}
                        alt="share"
                      />
                    </div>
                    <span>{t('share_link')}</span>
                  </div>
                </div>
                <p className="cancel" onClick={() => setSharing(false)}>
                  {t('cancel')}
                </p>
              </div>
            </div>
          )}
        </div>
      </StyledShareWrapper>
      <Footer />
    </StyledLonPageHelper>
  )
}

export default Share
